import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { rem, getResetByTag } from './../../../styles';
var iconStyles = function iconStyles() {
  return /*#__PURE__*/css("margin:", rem(4, 6, 0, 0), ";>svg{display:block;}" + (process.env.NODE_ENV === "production" ? "" : ";label:iconStyles;"));
};
var resetStyles = getResetByTag('div');
var StyledAlertIcon = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e13dkwwi0"
} : {
  target: "e13dkwwi0",
  label: "StyledAlertIcon"
})(resetStyles, iconStyles);
export default StyledAlertIcon;